<script setup lang="ts">
const { notifySuccess, notifyError } = useNotifications();
const open = defineModel<boolean>({ default: false });
const { t } = useI18n();
const { data: contactFormResponse, isPending: loading, error, mutate } = useValuationContact();

defineProps<{
  id: string
}>();

watch(contactFormResponse, (response) => {
  if (!response) return;
  open.value = false;
  notifySuccess(t('core.form.message_sent'));
});

watch(error, (error) => {
  if (!error) return;
  notifyError(t('core.error.notification'));
});
</script>

<template>
  <IadDialog
    v-model="open"
    modal-name="contact_agent"
  >
    <template #top-content>
      <IadTitle
        :text="$t('agent.form.seller.title')"
        variant="medium"
        tag="p"
      />
    </template>
    <div class="w-screen lg:max-w-3xl lg:max-w-md mx-auto px-m">
      <span
        class="text-sm font-semibold"
        v-text="$t('agent.form.seller.description')"
      />
      <AgentContactFormSeller
        :id
        class="pt-m"
        @update:form="mutate($event)"
      />
      <AgentDialogLegalMention />
    </div>
    <template #actions>
      <IadBtn
        :text="$t(`agent.form.send_message`)"
        class="w-full"
        :form="id"
        type="submit"
        :loading
        :disabled="loading"
      />
    </template>
  </IadDialog>
</template>
